<template>
  <nav class="flex flex-col text-sm gap-y-1">
    <!-- Dashboard -->
    <MenuLink
      href="/dashboard"
      :active="isUrl('dashboard')"
      :icon="icons.HomeIcon"
      label="Dashboard"
      :collapsed="collapsed"
    />

    <!-- DATA MASTER -->
    <div v-if="can('manage data master')">
      <Section label="Data Master" :collapsed="collapsed" />

      <Collapse
        v-slot="{ forceExpanded }"
        v-model="open.master"
        title="Data Master"
        :icon="icons.Squares2X2Icon"
        :collapsed="collapsed"
      >
        <MenuLink
          v-if="can('read persyaratan')"
          href="/persyaratans"
          :active="isUrl('persyaratans')"
          :icon="icons.ListBulletIcon"
          label="Persyaratan"
          :collapsed="collapsed"
          :force-expanded="forceExpanded"
        />

        <MenuLink
          v-if="can('read persyaratan pertanggungjawaban')"
          href="/persyaratan-pertanggungjawabans"
          :active="isUrl('persyaratan-pertanggungjawabans')"
          :icon="icons.ClipboardDocumentCheckIcon"
          label="Persyaratan PJ"
          :collapsed="collapsed"
          :force-expanded="forceExpanded"
        />

        <MenuLink
          v-if="can('read persyaratan pertanggungjawaban')"
          href="/expense-descriptions"
          :active="isUrl('expense-descriptions')"
          :icon="icons.BanknotesIcon"
          label="Uraian Biaya"
          :collapsed="collapsed"
          :force-expanded="forceExpanded"
        />

        <MenuLink
          v-if="can('read universitas')"
          href="/universities"
          :active="isUrl('universities')"
          :icon="icons.BuildingLibraryIcon"
          label="Universitas"
          :collapsed="collapsed"
          :force-expanded="forceExpanded"
        />

        <MenuLink
          v-if="can('read user')"
          href="/users"
          :active="isUrl('users')"
          :icon="icons.UsersIcon"
          label="User"
          :collapsed="collapsed"
          :force-expanded="forceExpanded"
        />

        <MenuLink
          v-if="can('read user')"
          href="/mahasiswas"
          :active="isUrl('mahasiswas')"
          :icon="icons.AcademicCapIcon"
          label="Mahasiswa"
          :collapsed="collapsed"
          :force-expanded="forceExpanded"
        />

        <MenuLink
          v-if="can('read role')"
          href="/roles"
          :active="isUrl('roles')"
          :icon="icons.KeyIcon"
          label="Role"
          :collapsed="collapsed"
          :force-expanded="forceExpanded"
        />

        <MenuLink
          v-if="can('read permission')"
          href="/permissions"
          :active="isUrl('permissions')"
          :icon="icons.ShieldCheckIcon"
          label="Permission"
          :collapsed="collapsed"
          :force-expanded="forceExpanded"
        />
      </Collapse>
    </div>

    <!-- BEASISWA -->
    <div v-if="can('manage beasiswa')">
      <Section label="Beasiswa" :collapsed="collapsed" />

      <Collapse
        v-if="!student"
        v-slot="{ forceExpanded }"
        v-model="open.beasiswa"
        title="Beasiswa"
        :icon="icons.AcademicCapIcon"
        :collapsed="collapsed"
      >
        <MenuLink
          v-if="can('read periode beasiswa')"
          href="/scholarships"
          :active="isUrl('scholarships')"
          :icon="icons.DocumentIcon"
          label="Periode Beasiswa"
          :collapsed="collapsed"
          :force-expanded="forceExpanded"
        />

        <MenuLink
          v-if="can('verify permohonan beasiswa')"
          href="/verify-scholar-applications"
          :active="isUrl('verify-scholar-applications')"
          :icon="icons.ClipboardDocumentListIcon"
          label="Verifikasi Permohonan"
          :collapsed="collapsed"
          :force-expanded="forceExpanded"
        />

        <MenuLink
          v-if="can('verify permohonan beasiswa')"
          href="/verified-scholar-applications"
          :active="isUrl('verified-scholar-applications')"
          :icon="icons.ChartBarIcon"
          label="Hasil Verifikasi"
          :collapsed="collapsed"
          :force-expanded="forceExpanded"
        />

        <MenuLink
          v-if="can('ranking permohonan beasiswa')"
          href="/verify-scholar-application-rank"
          :active="isUrl('verify-scholar-application-rank')"
          :icon="icons.BarsArrowUpIcon"
          label="Ranking Permohonan"
          :collapsed="collapsed"
          :force-expanded="forceExpanded"
        />
      </Collapse>

      <MenuLink
        v-if="can('read permohonan beasiswa')"
        href="/scholar-applications"
        :active="isUrl('scholar-applications')"
        :icon="icons.DocumentArrowDownIcon"
        label="Permohonan Beasiswa"
        :collapsed="collapsed"
        :force-expanded="forceExpanded"
      />
    </div>

    <!-- PERTANGGUNG JAWABAN -->
    <div v-if="can('manage pertanggungjawaban')">
      <Section label="Pertanggung Jawaban" :collapsed="collapsed" />
      <Collapse
        v-if="!student"
        v-slot="{ forceExpanded }"
        v-model="open.pertanggungjawaban"
        title="Pertanggung Jawaban"
        :icon="icons.ClipboardDocumentIcon"
        :collapsed="collapsed"
      >
        <MenuLink
          v-if="can('verify pertanggungjawaban')"
          href="/accountability-periodes"
          :active="isUrl('accountability-periodes')"
          :icon="icons.CalendarDaysIcon"
          label="Periode PJ"
          :collapsed="collapsed"
          :force-expanded="forceExpanded"
        />

        <MenuLink
          v-if="can('verify Rencanapertanggungjawaban')"
          href="/verify-accountability-reports"
          :active="isUrl('verify-accountability-reports')"
          :icon="icons.ClipboardDocumentCheckIcon"
          label="Verifikasi RAB"
          :collapsed="collapsed"
          :force-expanded="forceExpanded"
        />

        <MenuLink
          v-if="can('verify Rencanapertanggungjawaban')"
          href="/verified-accountability-reports"
          :active="isUrl('verified-accountability-reports')"
          :icon="icons.ChartBarSquareIcon"
          label="Hasil Verifikasi RAB"
          :collapsed="collapsed"
          :force-expanded="forceExpanded"
        />

        <MenuLink
          v-if="can('verify pertanggungjawaban')"
          href="/verify-final-reports"
          :active="isUrl('verify-final-reports')"
          :icon="icons.ClipboardDocumentListIcon"
          label="Verifikasi PJ"
          :collapsed="collapsed"
          :force-expanded="forceExpanded"
        />

        <MenuLink
          v-if="can('verify pertanggungjawaban')"
          href="/verified-final-reports"
          :active="isUrl('verified-final-reports')"
          :icon="icons.ChartBarIcon"
          label="Hasil Verifikasi PJ"
          :collapsed="collapsed"
          :force-expanded="forceExpanded"
        />

        <MenuLink
          v-if="can('verify pertanggungjawaban')"
          href="/monitoring-accountability"
          :active="isUrl('monitoring-accountability')"
          :icon="icons.ChartPieIcon"
          label="Monitoring PJ"
          :collapsed="collapsed"
          :force-expanded="forceExpanded"
        />
      </Collapse>

      <MenuLink
        v-if="can('read pertanggungjawaban')"
        href="/accountability-reports"
        :active="isUrl('accountability-reports')"
        :icon="icons.DocumentCheckIcon"
        label="Pertanggung Jawaban"
        :collapsed="collapsed"
        :force-expanded="forceExpanded"
      />
    </div>


    <!-- Laporan -->
    <div v-if="can('manage data master')">
      <Section label="Laporan" :collapsed="collapsed" />
      <Collapse
        v-if="!student"
        v-slot="{ forceExpanded }"
        v-model="open.laporan"
        title="Laporan"
        :icon="icons.ChartPieIcon"
        :collapsed="collapsed"
      >
        <MenuLink
          v-if="can('read user')"
          href="/report/kecamatan"
          :active="isUrl('report/kecamatan')"
          :icon="icons.MapIcon"
          label="Wilayah"
          :collapsed="collapsed"
          :force-expanded="forceExpanded"
        />
        <MenuLink
          v-if="can('read user')"
          href="/report/universitas"
          :active="isUrl('report/universitas')"
          :icon="icons.BuildingOffice2Icon"
          label="Perguruan Tinggi"
          :collapsed="collapsed"
          :force-expanded="forceExpanded"
        />
        <MenuLink
          v-if="can('read user')"
          href="/report/prodi"
          :active="isUrl('report/prodi')"
          :icon="icons.AcademicCapIcon"
          label="Program Studi"
          :collapsed="collapsed"
          :force-expanded="forceExpanded"
        />
      </Collapse>
    </div>
  </nav>
</template>

<script>
import MenuLink from './MenuLink.vue'
import Collapse from './Collapse.vue'
import Section from './Section.vue'

import {
  HomeIcon,
  Squares2X2Icon,
  ListBulletIcon,
  ClipboardDocumentCheckIcon,
  BuildingLibraryIcon,
  UsersIcon,
  KeyIcon,
  ShieldCheckIcon,
  AcademicCapIcon,
  DocumentIcon,
  ClipboardDocumentListIcon,
  ChartBarIcon,
  BarsArrowUpIcon,
  DocumentArrowDownIcon,
  ClipboardDocumentIcon,
  CalendarDaysIcon,
  ChartBarSquareIcon,
  DocumentCheckIcon,
  UserCircleIcon,
  ArrowLeftOnRectangleIcon,
  ChartPieIcon,
  MapIcon,
  BuildingOffice2Icon,
  BanknotesIcon
} from '@heroicons/vue/24/outline'

export default {
  components: { MenuLink, Collapse, Section },
  props: {
    auth: Object,
    collapsed: { type: Boolean, default: false },
    isUrl: { type: Function, required: true },
  },
  data() {
    const user = this.auth?.user || {}
    return {
      student: user.student,
      open: { master: false, beasiswa: false, pertanggungjawaban: false },
      icons: {
        HomeIcon,
        Squares2X2Icon,
        ListBulletIcon,
        ClipboardDocumentCheckIcon,
        BuildingLibraryIcon,
        UsersIcon,
        KeyIcon,
        ShieldCheckIcon,
        AcademicCapIcon,
        DocumentIcon,
        ClipboardDocumentListIcon,
        ChartBarIcon,
        BarsArrowUpIcon,
        DocumentArrowDownIcon,
        ClipboardDocumentIcon,
        CalendarDaysIcon,
        ChartBarSquareIcon,
        DocumentCheckIcon,
        UserCircleIcon,
        ArrowLeftOnRectangleIcon,
        ChartPieIcon,
        MapIcon,
        BuildingOffice2Icon,
        BanknotesIcon,
      },
    }
  },
  watch: {
    collapsed(val) {
      if (!val) return
      this.open.master = false
      this.open.beasiswa = false
      this.open.pertanggungjawaban = false
    },
  },
}
</script>
